var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "-0.6 572.4 2000.6 884.6",
    zoomAndPan: "magnify",
    style: {
      fill: "rgb(0, 0, 0)"
    },
    original_string_length: 2258,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "__id108_sdhlajw49",
    style: {
      fill: "rgb(217, 217, 217)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1031.11,709.19c-299.3-1.4-556.74,46.12-593.88,50.82c-59.41,7.52-78.92,48.37-78.92,48.37L243.24,1060.7 c20.33-2.46,46.55-5.64,77.66-9.42c7-478.83,1215.13-293.89,1255.61-266.93C1405.34,728.49,1210.69,710.03,1031.11,709.19z",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.7,775.88c0,0,313.5-53.81,809.49,35.09c-4.68-4.68,95.92,79.55,149.73,252.67 C1719.58,1061.31,386.03,946.67,0,1248.47c7.02-9.36,166.11-175.47,643.38-217.58c477.27-42.11,1045.79,67.85,977.94-93.58 C1553.47,775.88,1183.82,775.88,762.7,775.88z",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.33,1058.38l-40.36,37.43c0,0-26.9-34.51-118.73-31c-91.83,3.51-41.53-98.26,12.87-99.43 c54.39-1.17,107.04-10.53,102.94,17.55s-4.68,64.92-12.87,68.43c-8.19,3.51,0.58-80.13-67.26-67.26 c-67.85,12.87-54.39,40.36-37.43,46.79c16.96,6.43,41.53-9.94,62,14.04C171.96,1068.91,232.2,1081.78,250.33,1058.38z",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1717.74,1062.5l40.36,37.43c0,0,26.9-34.51,118.73-31c91.83,3.51,41.53-98.26-12.87-99.43 c-54.4-1.17-107.04-10.53-102.94,17.55c4.09,28.07,4.68,64.92,12.87,68.43c8.19,3.51-0.59-80.13,67.26-67.26 c67.85,12.87,54.4,40.36,37.43,46.79c-16.96,6.43-41.53-9.94-62,14.04C1796.11,1073.02,1735.87,1085.89,1717.74,1062.5z",
    style: {
      fill: "inherit"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1059.3,1068.32c-227.27,0.77-475.86,25.68-750.18,108.8l0.45-0.09c421.88-101.04,909.43-98.94,1259.47-73.62 c-1.16,0.06-1.7,0.05-2.88,0.1c-46.92,2.4-75.36,9.32-137.77,14.89c-62.42,5.57-125.17,12.69-173.46,21.39 c-24.14,4.35-44.65,9.08-59.84,14.27c-7.6,2.6-13.86,5.32-18.66,8.26c-4.8,2.94-8.33,6.1-9.77,10.21 c-1.49,4.27,0.42,8.8,3.95,12.11c443.73,272.45,746.32-244.28,819.3,106.2c3.43-0.24,6.83-0.46,10.09-0.53 c-14.91-105.18-69.1-131.09-90.33-166.48c-6.61-11.02-15.39-16.19-24.38-17.01c-8.98-0.81-17.87,2.43-25.75,6.75 c-58.05,43.51-128.76,70.73-196.41,83.53c-70.41,12.69-150.07,17.85-224.46,17.78c-357.84-64.46,63.36-93.11,242.91-110.5 C1492.5,1090.92,1286.55,1067.55,1059.3,1068.32z",
    style: {
      fill: "inherit"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarLogo);
export default __webpack_public_path__ + "static/media/car-logo.f3edc6d3cf1bd646cf6da0c80611c3f9.svg";
export { ForwardRef as ReactComponent };